<template>
     <!-- <q-btn label="Click me"  /> -->
  <!-- <Header /> -->
     <router-view></router-view>
    <!-- <Footer /> -->
</template>

<script>

// import 'quasar/dist/quasar.css'
export default {
  name: 'App',
}
</script>

<style>
/* .wizard-navigation .wizard-nav.wizard-nav-pills {
    li:nth-child(3),li:nth-child(4),li:nth-child(5){
        display: none !important;
    }
} */
.wizard-btn{
    color: #fff;
    background-color: #276ca5;
    border-color: #276ca5;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    border: 1px solid transparent;
    line-height: 1.42857143;
    font-weight: 700 !important;
    min-width: 220px !important;
    height: 50px;
    transition: all 0.3s;
    border-width: 3px;
    border-radius: 25px !important;
    padding: 8px 20px;
    font-size: 16px !important;
}
@media (max-width: 480px) {
    .wqa-design .header__search.open {
        top: 62px !important;
    }
}
@media (max-width:768px){
    
	.wizard-btn{
		min-width:140px !important;
	}
    .wizard-nav.wizard-nav-pills,.wizard-progress-with-circle{
            display: none !important;
        }
    #app{
    margin-top: 60px !important;
    }
    
    .mobile_sort_by_items {
            display:block !important;
        }
}
@media (max-width:1025px){
    .register-form{
        margin-top:0 !important;
    }
}
.vue-form-wizard{
    padding-bottom: 30px;
}
.vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle{
    top: 75px !important;
}
.vue-form-wizard.sm .wizard-navigation .wizard-nav.wizard-nav-pills li a{
    display: flex;
    flex-direction: column-reverse;
}
.wizard-progress-with-circle {
    background-color: #cccccc !important;
    width: 80% !important;
    margin: 0 auto;
}
.vue-form-wizard .wizard-nav-pills{
    margin-top: 15px !important;
    padding-bottom: 5px;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  flex-wrap: nowrap !important;
}
.vue-form-wizard .wizard-card-footer {
    padding: 0 40px;
    width: 100%;
    /* display: flex;
    justify-content: space-between; */
    max-width: 1000px;
    margin: 0 auto;
}
.vue-form-wizard.sm .wizard-icon-circle.tab_shape {
    height: 45px !important;
}
.wqa-design .btn{font-size: 16px !important;}
.filterDesktopView__filter_section {
        background-color: #fafafa;
        /* max-width: 318px; */
        min-width: 302px;
        max-width: 318px;
        position: sticky;
        position: -webkit-sticky;
        top: 110px;
        width: 100%;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_header {
        align-items: center;
        border-bottom: 1px solid #e4e4e4;
        display: flex;
        height: 62px;
        justify-content: space-between;
        margin: 0 10px;
        padding: 0 5px;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_header .filterDesktopView__lbl {
        /* font-family: gt-walsheim-bold; */
        font-family:"Raleway", sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        text-transform: uppercase;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_header .filterDesktopView__lbl .filterDesktopView__icon {
        margin-right: 10px;
    }
    .icon__icon {
        display: inline-flex;
        position: relative;
        width: fit-content;
    }
    .icon__icon .icon__svg_wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_header .filterDesktopView__clear_link {
        color: #000;
        cursor: pointer;
        /* font-family: gt-walsheim-medium; */
        font-family: "Raleway", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-decoration: underline;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_details {
        max-height: 600px;
        overflow-y: auto;
        padding: 28px 33px;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_details>ul>li .filterDesktopView__title {
        align-items: center;
        cursor: pointer;
        display: flex;
        /* font-family: gt-walsheim-bold; */
        font-family: "Raleway", sans-serif;
        font-size: 16px;
        font-weight: 700;
        height: 48px;
        justify-content: space-between;
        line-height: 20px;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_details>ul>li {
        /* border-bottom: 1px solid #e4e4e4; */
    }
    ol, ul {
        list-style: none;
    }
    
    /* add-to-cart styles */
    /* .standard-type__tile_bottom_section {
        bottom: 0;
        position: absolute;
    } */
    .standard-type__price_details {
        /* margin-top: 12px; */
        /* margin-top: 40px; */
        margin-bottom: 20px;
        margin-left:10px;
    }
    .standard-type__price_details .standard-type__offer {
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 2px;
        text-align: left;
    }
    .standard-type__price_details .standard-type__offer .standard-type__strikethrough_price {
        text-decoration: line-through;
    }
    .standard-type__price_details .standard-type__price {
        align-items: center;
        display: flex;
        /* font-family: gt-walsheim-bold; */
        font-family: "Raleway", sans-serif;
        font-size: 18px;
        font-weight: 700;
        gap: 4px;
        line-height: 24px;
        margin-bottom: 2px;
    }
    .standard-type__price_details .standard-type__txt {
        color: #949494;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
    }
    .button__button {
        margin-bottom: 27px;
        -webkit-tap-highlight-color: transparent;
        border: none;
        border-radius: 40px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        /* font-family: gt-walsheim-bold; */
        font-family: "Raleway", sans-serif;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 18px;
        overflow: hidden;
        padding: 11px 32px;
        text-align: center;
        text-overflow: ellipsis;
        text-transform: uppercase;
        white-space: nowrap;
    }
    .all__background_dark_gray {
        background-color: #2c2c2c;
    }
    
    .standard-type__product_name {
        color:#354657;
        -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    min-height: 40px;
    max-height: 40px;
        /* font-family: gt-walsheim-bold; */
        font-family: "Raleway", sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        overflow: hidden;
        text-transform: capitalize;
    }
    
    
    /* banner css */
    @media (min-width: 768px) {
        
        .sortByDropdown__sort_by_dropdown {
            margin-right: 0;
        }
        .banner__banner_container .banner__title_details {
            bottom: 0;
            height: 66px;
            left: 22px;
            margin: auto;
            top: 0;
        }
        .banner__banner_container .banner__title_details .banner__results_count {
            font-size: 16px;
            line-height: 20px;
        }
        .banner__banner_container .banner__title_details .banner__title {
            font-size: 32px;
            line-height: 46px;
            margin-bottom: 0;
        }
        .banner__banner_container {
            height: 200px;
            margin-bottom: 28px;
        }
    }
    .banner__banner_container .banner__banner_img img {
        height: 100%;
        max-width: 100%;
    }
    .banner__banner_container {
        height: 178px;
        /* height: 119px; */
        margin-bottom: 21px;
        position: relative;
        width: 100%;
    }
    .banner__banner_container .banner__banner_img {
        bottom: 0;
        height: 100%;
        position: absolute;
        right: 0;
    }
    .banner__banner_container .banner__title_details {
        bottom: 8px;
        left: 25px;
        position: absolute;
    }
    .banner__banner_container .banner__title_details .banner__title {
        /* font-family: gt-walsheim-medium; */
        font-family: "Raleway", sans-serif;
        font-size: 24px;
        font-weight: 400;
        line-height: 28px;
        margin-bottom: 4px;
    }
    .grid{
        border-color:  #f4f4f4 !important;
    
        /* border: 2px solid #fafafa;
        border-radius: 23px; */
    }
    
    /* floating filters */
    .sortFilterBar__bottom_btn_bar {
        bottom: 10px;
        /* margin-bottom: 32px; */
        padding: 0 13px;
        position: sticky;
        position: -webkit-sticky;
        z-index: 7;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper {
        align-items: center;
        background-color: #2c2c2c;
        border-radius: 10px;
        color: #fff;
        display: flex;
        flex-direction: row;
        height: 56px;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper .sortFilterBar__btn_area {
        align-items: center;
        display: flex;
        font-size: 16px;
        justify-content: center;
        line-height: 20px;
        width: 49%;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper .sortFilterBar__btn_area .sortFilterBar__btn {
        position: relative;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper .sortFilterBar__seperator {
        background-color: #fff;
        height: 33px;
        width: .5px;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper .sortFilterBar__btn_area {
        align-items: center;
        display: flex;
        font-size: 16px;
        justify-content: center;
        line-height: 20px;
        width: 49%;
    }
    .sortFilterBar__bottom_btn_bar .sortFilterBar__btn_wrapper .sortFilterBar__btn_area .sortFilterBar__btn {
        position: relative;
    }
    .modal__wrapper.modal__hide_modal {
        display: none;
    }
    .modal__wrapper.modal__hide_modal {
        display: none;
    }
    .modal__wrapper .modal__modal_main_container {
        border-radius: 3px;
        bottom: 0;
        box-shadow: 0 0 6px #9b9b9b;
        display: flex;
        flex-direction: column;
        left: 0;
        max-height: 82vh;
        min-height: 309px;
        position: fixed;
        right: 0;
        transform: translateX(300em);
        width: 100%;
        z-index: 75599;
    }
    .modal__icon_wrpper_xs .modal__close_icon_xs {
        align-items: center;
        background: hsla(0, 0%, 100%, .3);
        border-radius: 100%;
        display: flex;
        justify-content: center;
        padding: 19px;
    }
    .icon__icon {
        display: inline-flex;
        position: relative;
        width: fit-content;
    }
    
    /* sticky filter */
    .sticky-div {
      display: none;
    }
    
    @media (max-width: 1130px) {
        .filterDesktopView__filter_section ,.catalog-sort-container{
            display: none !important;
        }
      /* Show the div on mobile */
      .sticky-div {
        display: block;
        position: fixed !important;
        bottom: 0;
        left:0;
        width: 100%;
        /* background-color: white; Or any other background */
        /* box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); Optional shadow */
      }
    }
    .standard-type__tag {
        background-color: #fb5480;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        left: 8px;
        line-height: 14px;
        padding: 3px 6px;
        position: absolute;
        top: 8px;
    }
    .standard-type__tag.fast_selling {
        background-color: #fb7b54;
    }
    .standard-type__tag.out_of_stock {
        background-color: #a5fb54;
    }
    .standard-type__tag.new_product {
        background-color: #fb5480;
    }
    
    /* sort dropdown  */
    .sortByDropdown__sort_by_dropdown {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 28px;
    }
    .sortByDropdown__sort_by_dropdown_mobile {
        background: white;
        border-radius: 15px 15px 0px 0px;
        display: flex;
        justify-content: center;
        text-align: center;
        height: fit-content;
    }
    .sortByDropdown__filter_dropdown_mobile {
        display: flex;
        justify-content: center;
        background: white;
        border-radius: 15px 15px 0px 0px;
        text-align: center;
        height: fit-content;
        /* height: 600px; */
        /* height: 350px; */
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown {
        align-items: center;
        background: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        display: flex;
        height: 50px;
        padding: 0 20px;
        /* padding: 0 34px; */
        position: relative;
        width: 208px;
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown .sortByDropdown__selected_option {
        align-items: center;
        cursor: pointer;
        display: flex;
        font-size: 15px;
        justify-content: space-between;
        width: 100%;
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown .sortByDropdown__options {
        background-color: #fff;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
        display: none;
        left: 0;
        padding: 0 12px;
        position: absolute;
        top: 50px;
        width: 100%;
        z-index: 1;
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown .sortByDropdown__options.sortByDropdown__show {
        display: flex;
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown .sortByDropdown__options ul {
        width: 100%; padding: 0;
    }
    .sortByDropdown__sort_by_dropdown .sortByDropdown__custom_dropdown .sortByDropdown__options ul li {
        align-items: center;
        cursor: pointer;
        display: flex;
        font-size: 14px;
        height: 50px;
        justify-content: space-between;
        line-height: 20px;
    }
    
    /* category checkboxes */
    .checkbox__custom_checkbox_area .checkbox__inner_wrapper {
        align-items: center;
        display: flex;
    }
    .checkbox__custom_checkbox_area .checkbox__inner_wrapper .checkbox__custom_checkbox {
        cursor: pointer;
        /* height: 20px;
        margin-right: 14px; */
        /* width: 20px; */
    }
    .checkbox__custom_checkbox_area .checkbox__inner_wrapper .checkbox__checkbox_txt {
        color: #2c2c2c;
        /* font-family: gt-walsheim-regular; */
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_details>ul>li .filterDesktopView__options>ul li {
        margin-bottom: 17px;
    }
    .filterDesktopView__filter_section .filterDesktopView__filter_details>ul>li .filterDesktopView__options>ul{
        padding: 0;
    }
    
    /* filter stick css */
    .fixed {
      position: fixed !important;
      top: 110px;
      left: 15px;
      width: 25%; 
      /* z-index: -1; */
    }
    
    
    .modal__active.modal__modal_backdrop.modal__defaultBackground {
        backdrop-filter: blur(10px);
        background: rgba(44, 44, 44, .7);
        animation: fade 150ms linear;
        overscroll-behavior: contain;
    }
    @keyframes fade {
      0% { opacity: 0 }
      100% { opacity: 1 }
    }
    .modal__active.modal__modal_backdrop {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        opacity: 1;
        position: fixed;
        top: 0;
        visibility: visible;
        width: 100%;
        z-index: 75541;
    }
    .overflow-hidden{
        overflow: hidden;
    }
    
    /* secondary page css */
    div.secondary-page{
        max-width: none !important;
    }
    
    .standard-type__tile_bottom_section {
        text-align: center !important;
    }
    
    
    .filterDesktopView__filter_details >ul>li{
        border: none !important;
    }
    
    .sortByDropdown__txt_bold {
      font-weight: bold;
      color: #000;
    }
    
    .mobile_modal.modal__modal_main_container.active{
        z-index:23132323;
        display: flex;
        position:absolute;
        overflow:hidden;
    }
    .mobile_modal{
        display:none;
    }
    .modal__modal_main_container{
        flex-direction: column;
        left: 0;
        /* max-height: 82vh; */
        min-height: 132px;
        position: fixed;
        right: 0;
        width: 100%;
        z-index: 75599;
        bottom: -33px;
        margin-bottom: 0px;
        background-color:transparent;
        /* background-color: #fff; */
        border-radius: 20px 20px 0 0;
        flex-grow: 1;
        font-size: 14px;
        overflow-y: auto;
    }
    
    .mobile_sort_by_items{
        display: flex;
        justify-content: space-around;
        padding:0px;margin-bottom: 30px;
    }
      .paginationDiv{
        display:flex;
        justify-content:center;
        align-items:center;
      }
#app {
  font-family: "Raleway",sans-serif;
  font-variant-numeric: lining-nums;
  -ms-font-feature-settings: "lnum" on;
  font-feature-settings: "lnum" on;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 80px;
}

body{
    background-color: white !important;
}

.custom-swal-popup{
    border-radius:15px;
}
</style>
